import * as Types from '../../../types/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VerifyPasskeyAuthenticationMutationVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
  credential: Types.Scalars['String']['input'];
}>;


export type VerifyPasskeyAuthenticationMutation = (
  { __typename?: 'Mutation' }
  & { passkeyAuthenticationVerify: (
    { __typename?: 'PasskeyAuthResult' }
    & Pick<Types.PasskeyAuthResult, 'accessExpires' | 'refreshExpires'>
  ) }
);

export type LogoutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'logout'>
);

export type RefreshTokenMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = (
  { __typename?: 'Mutation' }
  & { refreshToken: (
    { __typename?: 'PasskeyAuthResult' }
    & Pick<Types.PasskeyAuthResult, 'accessExpires' | 'refreshExpires'>
  ) }
);

export type PasskeyRegistrationOptionsMutationVariables = Types.Exact<{
  passkeyName: Types.Scalars['String']['input'];
}>;


export type PasskeyRegistrationOptionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'passkeyRegistrationOptions'>
);

export type PasskeyRegistrationVerifyMutationVariables = Types.Exact<{
  passkeyName: Types.Scalars['String']['input'];
  credential: Types.Scalars['String']['input'];
}>;


export type PasskeyRegistrationVerifyMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'passkeyRegistrationVerify'>
);

export type PasskeyRevokeMutationVariables = Types.Exact<{
  passkeyId: Types.Scalars['Int']['input'];
}>;


export type PasskeyRevokeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'passkeyRevoke'>
);

export type PasskeyAuthenticationOptionsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PasskeyAuthenticationOptionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'passkeyAuthenticationOptions'>
);


export const VerifyPasskeyAuthenticationDocument = gql`
    mutation verifyPasskeyAuthentication($sessionId: String!, $credential: String!) {
  passkeyAuthenticationVerify(sessionId: $sessionId, credential: $credential) {
    accessExpires
    refreshExpires
  }
}
    `;
export type VerifyPasskeyAuthenticationMutationFn = Apollo.MutationFunction<VerifyPasskeyAuthenticationMutation, VerifyPasskeyAuthenticationMutationVariables>;

/**
 * __useVerifyPasskeyAuthenticationMutation__
 *
 * To run a mutation, you first call `useVerifyPasskeyAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasskeyAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPasskeyAuthenticationMutation, { data, loading, error }] = useVerifyPasskeyAuthenticationMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      credential: // value for 'credential'
 *   },
 * });
 */
export function useVerifyPasskeyAuthenticationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPasskeyAuthenticationMutation, VerifyPasskeyAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPasskeyAuthenticationMutation, VerifyPasskeyAuthenticationMutationVariables>(VerifyPasskeyAuthenticationDocument, options);
      }
export type VerifyPasskeyAuthenticationMutationHookResult = ReturnType<typeof useVerifyPasskeyAuthenticationMutation>;
export type VerifyPasskeyAuthenticationMutationResult = Apollo.MutationResult<VerifyPasskeyAuthenticationMutation>;
export type VerifyPasskeyAuthenticationMutationOptions = Apollo.BaseMutationOptions<VerifyPasskeyAuthenticationMutation, VerifyPasskeyAuthenticationMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken {
  refreshToken {
    accessExpires
    refreshExpires
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const PasskeyRegistrationOptionsDocument = gql`
    mutation passkeyRegistrationOptions($passkeyName: String!) {
  passkeyRegistrationOptions(passkeyName: $passkeyName)
}
    `;
export type PasskeyRegistrationOptionsMutationFn = Apollo.MutationFunction<PasskeyRegistrationOptionsMutation, PasskeyRegistrationOptionsMutationVariables>;

/**
 * __usePasskeyRegistrationOptionsMutation__
 *
 * To run a mutation, you first call `usePasskeyRegistrationOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyRegistrationOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyRegistrationOptionsMutation, { data, loading, error }] = usePasskeyRegistrationOptionsMutation({
 *   variables: {
 *      passkeyName: // value for 'passkeyName'
 *   },
 * });
 */
export function usePasskeyRegistrationOptionsMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyRegistrationOptionsMutation, PasskeyRegistrationOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyRegistrationOptionsMutation, PasskeyRegistrationOptionsMutationVariables>(PasskeyRegistrationOptionsDocument, options);
      }
export type PasskeyRegistrationOptionsMutationHookResult = ReturnType<typeof usePasskeyRegistrationOptionsMutation>;
export type PasskeyRegistrationOptionsMutationResult = Apollo.MutationResult<PasskeyRegistrationOptionsMutation>;
export type PasskeyRegistrationOptionsMutationOptions = Apollo.BaseMutationOptions<PasskeyRegistrationOptionsMutation, PasskeyRegistrationOptionsMutationVariables>;
export const PasskeyRegistrationVerifyDocument = gql`
    mutation passkeyRegistrationVerify($passkeyName: String!, $credential: String!) {
  passkeyRegistrationVerify(passkeyName: $passkeyName, credential: $credential)
}
    `;
export type PasskeyRegistrationVerifyMutationFn = Apollo.MutationFunction<PasskeyRegistrationVerifyMutation, PasskeyRegistrationVerifyMutationVariables>;

/**
 * __usePasskeyRegistrationVerifyMutation__
 *
 * To run a mutation, you first call `usePasskeyRegistrationVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyRegistrationVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyRegistrationVerifyMutation, { data, loading, error }] = usePasskeyRegistrationVerifyMutation({
 *   variables: {
 *      passkeyName: // value for 'passkeyName'
 *      credential: // value for 'credential'
 *   },
 * });
 */
export function usePasskeyRegistrationVerifyMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyRegistrationVerifyMutation, PasskeyRegistrationVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyRegistrationVerifyMutation, PasskeyRegistrationVerifyMutationVariables>(PasskeyRegistrationVerifyDocument, options);
      }
export type PasskeyRegistrationVerifyMutationHookResult = ReturnType<typeof usePasskeyRegistrationVerifyMutation>;
export type PasskeyRegistrationVerifyMutationResult = Apollo.MutationResult<PasskeyRegistrationVerifyMutation>;
export type PasskeyRegistrationVerifyMutationOptions = Apollo.BaseMutationOptions<PasskeyRegistrationVerifyMutation, PasskeyRegistrationVerifyMutationVariables>;
export const PasskeyRevokeDocument = gql`
    mutation passkeyRevoke($passkeyId: Int!) {
  passkeyRevoke(passkeyId: $passkeyId)
}
    `;
export type PasskeyRevokeMutationFn = Apollo.MutationFunction<PasskeyRevokeMutation, PasskeyRevokeMutationVariables>;

/**
 * __usePasskeyRevokeMutation__
 *
 * To run a mutation, you first call `usePasskeyRevokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyRevokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyRevokeMutation, { data, loading, error }] = usePasskeyRevokeMutation({
 *   variables: {
 *      passkeyId: // value for 'passkeyId'
 *   },
 * });
 */
export function usePasskeyRevokeMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyRevokeMutation, PasskeyRevokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyRevokeMutation, PasskeyRevokeMutationVariables>(PasskeyRevokeDocument, options);
      }
export type PasskeyRevokeMutationHookResult = ReturnType<typeof usePasskeyRevokeMutation>;
export type PasskeyRevokeMutationResult = Apollo.MutationResult<PasskeyRevokeMutation>;
export type PasskeyRevokeMutationOptions = Apollo.BaseMutationOptions<PasskeyRevokeMutation, PasskeyRevokeMutationVariables>;
export const PasskeyAuthenticationOptionsDocument = gql`
    mutation passkeyAuthenticationOptions {
  passkeyAuthenticationOptions
}
    `;
export type PasskeyAuthenticationOptionsMutationFn = Apollo.MutationFunction<PasskeyAuthenticationOptionsMutation, PasskeyAuthenticationOptionsMutationVariables>;

/**
 * __usePasskeyAuthenticationOptionsMutation__
 *
 * To run a mutation, you first call `usePasskeyAuthenticationOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyAuthenticationOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyAuthenticationOptionsMutation, { data, loading, error }] = usePasskeyAuthenticationOptionsMutation({
 *   variables: {
 *   },
 * });
 */
export function usePasskeyAuthenticationOptionsMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyAuthenticationOptionsMutation, PasskeyAuthenticationOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyAuthenticationOptionsMutation, PasskeyAuthenticationOptionsMutationVariables>(PasskeyAuthenticationOptionsDocument, options);
      }
export type PasskeyAuthenticationOptionsMutationHookResult = ReturnType<typeof usePasskeyAuthenticationOptionsMutation>;
export type PasskeyAuthenticationOptionsMutationResult = Apollo.MutationResult<PasskeyAuthenticationOptionsMutation>;
export type PasskeyAuthenticationOptionsMutationOptions = Apollo.BaseMutationOptions<PasskeyAuthenticationOptionsMutation, PasskeyAuthenticationOptionsMutationVariables>;